import { Body } from './body';
import { Header } from './header';
import { Wrapper } from './wrapper';

export function PaymentSuccess({
  successLogo,
  onClose,
}: {
  successLogo: string;
  onClose: () => void;
}) {
  return (
    <Wrapper>
      <Header onClose={onClose} title="Payment Successful!" />
      <Body percentage={100} successLogo={successLogo} />
    </Wrapper>
  );
}
